import { type MouseEventHandler } from 'react';
import classNames from 'classnames';

import { Button, ButtonColor, ButtonShape, ButtonSize, createIconComponent } from '@jsmdg/yoshi';
import { ReactComponent as ControlsPlayIcon } from '../../assets/icons/controls-play.svg';
import styles from './PlayButton.module.scss';

const PlayIcon = createIconComponent(ControlsPlayIcon);

type PlayButtonProps = {
    readonly a11yText: string;
    readonly className?: string;
    readonly iconClasses?: string;
    readonly noHover?: boolean;
    readonly size?: ButtonSize;
    readonly onClickHandler?: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>;
};

const PlayButton = ({
    a11yText,
    className,
    iconClasses,
    noHover,
    onClickHandler,
    size = ButtonSize.Large,
}: PlayButtonProps) => {
    return (
        <Button
            size={size}
            shape={ButtonShape.Icon}
            color={ButtonColor.White}
            className={classNames(!noHover && styles.hover, styles.playButton, className)}
            a11yText={a11yText}
            onClick={onClickHandler}
        >
            <PlayIcon className={classNames(iconClasses, styles.playIcon)} />
        </Button>
    );
};

export { PlayButton };
